export default __webpack_public_path__ + "static/media/cabinet1-after-1920w.74313c77.avif";